import { administrationRequests } from "api/administrationApi";
import ScheduledItemFields from "./ScheduledItemFields";

const InternshipFields = props => (
  <ScheduledItemFields
    {...props}
    source="internshipId"
    reference={administrationRequests.getInternshipsSelect()}
    label="Стаж"
  />
);

export default InternshipFields;
